<div class="grid mt-2 ml-3 overview-details mr-0">
    <div class="col-6 md:col-12 lg:col-6 pl-0">

        <div class="card p-fluid">
            <div class="flex justify-content-between flex-wrap">
                <div class="flex justify-content-center mb-3">
                    <label class="card-heading uppercase font-bold" translate>product.lbl_overview_details</label>
                </div>
                <div class="edit justify-content-center mb-3 cursor-pointer" [ngClass]="{'hidden': !isDeleted}" (click)="redirectToEdit()">
                    <label class="card-action" translate>product.lbl_edit</label>
                    <i class="mi-lg edit_pencil"></i>
                </div>
            </div>
            <div class="grid">
                <div class="col-4  pt-1">
                    <label class="detail-heading" translate>{{cs.getLabelValue('product.fields.product_status.label',attributeLabels,'product_status')}}</label>
                </div>
                <div class="col-8  pb-1">
                    @for (item of attributeValues['product_status'] | keyvalue; track item.key) {
                        <span class="status-dot" [ngClass]="{
                            'bg-green-500':item.value ?.toLowerCase() === 'active',
                            'bg-red-500': item.value ?.toLowerCase() === 'inactive'
                          }"></span>     <label class="detail-value">{{ item.value }}</label>
                    }
                    
                </div>
            </div>
            <hr class="hr-line">

            <div class="grid">
                <div class="col-4  pt-1">
                    <label class="detail-heading" translate>{{cs.getLabelValue('product.fields.product_code.label',attributeLabels,'product_code')}}</label>
                </div>
                <div class="col-8  pb-1">
                        <label class="detail-value">{{ attributeValues['product_code'] ? attributeValues['product_code'] : '--' }}</label>
                    
                </div>
            </div>
            <hr class="hr-line">

            <div class="grid">
                <div class="col-4  pt-1">
                    <label class="detail-heading" translate>{{cs.getLabelValue('product.fields.product_name.label',attributeLabels,'product_name')}}</label>
                </div>
                <div class="col-8  pb-1">
                        <label class="detail-value">{{ attributeValues['product_name'] ? attributeValues['product_name'] : '--' }}</label>
                    
                </div>
            </div>
            <hr class="hr-line">


            <!-- <div class="grid">
                <div class="col-4  pt-1">
                    <label class="detail-heading" translate>{{cs.getLabelValue('product.fields.description.label',attributeLabels,'description')}}</label>
                </div>
                <div class="col-8  pb-1">
                        <label class="detail-value">{{ attributeValues['description'] ? attributeValues['description'] : '--' }}</label>
                    
                </div>
            </div> -->
            <!-- <hr class="hr-line"> -->

            <div class="grid">
                <div class="col-4  pt-1">
                    <label class="detail-heading" translate>{{cs.getLabelValue('product.fields.strength.label',attributeLabels,'strength')}}</label>
                </div>
                <div class="col-8  pb-1">
                        <label class="detail-value">{{ attributeValues['strength'] ? attributeValues['strength'] : '--' }}</label>
                    
                </div>
            </div>

            <hr class="hr-line">

            <div class="grid">
                <div class="col-4  pt-1">
                    <label class="detail-heading" translate>lbl_pack_size</label>
                </div>
                <div class="col-8  pb-1">
                    <label class="detail-value">{{ attributeValues['pack_size'] ? attributeValues['pack_size'] : '--' }}</label>
                </div>
            </div>

            <hr class="hr-line">

            <div class="grid">
                <div class="col-4  pt-1">
                    <label class="detail-heading" translate>lbl_pack_type</label>
                </div>
                <div class="col-8  pb-1">
                     <label class="detail-value">{{ packTypeValue ? packTypeValue : '--' }}</label>
                </div>
            </div>

            <hr class="hr-line">

            <div class="grid">
                <div class="col-4  pt-1">
                    <label class="detail-heading" translate>{{cs.getLabelValue('product.fields.presentation.label',attributeLabels,'presentation')}}</label>
                </div>
                <div class="col-8  pb-1">
                        <label class="detail-value">{{ attributeValues['presentation'] ? attributeValues['presentation'] : '--' }}</label>
                    
                </div>
            </div>
            <hr class="hr-line">

            <div class="grid">
                <div class="col-4  pt-1">
                    <label class="detail-heading" translate>{{cs.getLabelValue('product.fields.storage.label',attributeLabels,'storage')}}</label>
                </div>
                <div class="col-8  pb-1">
                        <label class="detail-value">{{ storageValue ? storageValue : '--' }}</label>
                    
                </div>
            </div>
            
            <hr class="hr-line"> 
            <div class="grid">
                <div class="col-4  pt-1">
                    <label class="detail-heading" translate>{{cs.getLabelValue('product.fields.entity_created_at.label',attributeLabels,'entity_created_at')}}</label>
                </div>
                <div class="col-8  pb-1">
                        <label class="detail-value">{{ attributeValues['entity_created_at'] ? metaDataService.formatDateTimeOnTZ( attributeValues['entity_created_at'], 'DD MMM YYYY, hh:mm A') : '--' }}</label>
                    
                </div>
            </div>
        </div>


    </div>

</div>
